// extracted by mini-css-extract-plugin
module.exports = {"container":"swipeSlider_container__4RLvp","card":"swipeSlider_card__7qekh"};